import React, { useState, useEffect } from "react";
import classes from "./RemittanceUpload.module.css";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { BASE_URL } from '../../../../Components/Styles/API/API';
import Swal from "sweetalert2";
import crop from "../../../../Assets/repoort.png";
import verified from "../../../../Assets/verified.svg";
import RotatingLogo from '../../../../Assets/rotating-logo.png'
import { Button, Modal, Form, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import Select from "react-select";


function RemitanceUpload({ isOpen, onClose }) {
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false }
  ]);
  const [reference, setReference] = useState("");
  const [loadingRef, setLoadingRef] = useState(false);
  const [loading, setLoading] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [incomeAccount, setIncomeAccount] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [balances, setBalances] = useState([]);
  const [createLoading, setCreateLoading] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [bearer, setBearer] = useState('');
  const [permits, setPermits] = useState([]);
  const [user, setUser] = useState('');
  const [company, setCompany] = useState('');
  const [region, setRegion] = useState('');
  const [province, setProvince] = useState('');
  const [currentMonth, setCurrentMonth] = useState('');
  const [provinceID, setProvinceID] = useState('');
  const [admin, setAdmin] = useState("");
  const [continent, setContinent] = useState('');
  const [validity, setValidity] = useState('');
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState('')
  const [outstanding, setOutstanding] = useState("");
   const [cus, setCus] = useState([]);
const [loans, setLoans] = useState([]);
   const [selectOptions, setSelectOptions] = useState([]);
   const [selectedBanks, setSelectedBanks] = useState(null)
    const [debit3, setDebit3] = useState([]);
      const [debit2, setDebit2] = useState([]);
      const [debit4, setDebit4] = useState([]);
        const [debit1, setDebit1] = useState([]);
           const [teller, setTeller] = useState("")
           const [excelFile, setExcelFile] = useState(null);
           const [uuid, setUuid] = useState(null);
      const readData = async () => {
        try {
          const value = localStorage.getItem('userToken');
          const value1 = localStorage.getItem('tobi');
          // const value2 = localStorage.getItem('permissions');
          const value3 = localStorage.getItem('admin');
          const value7 = localStorage.getItem('companyName');
          const value8 = localStorage.getItem('validity');
          const permitsss = localStorage.getItem('permissions');
          const continentName = localStorage.getItem('continent');
          const regionName = localStorage.getItem('region');
          const provinceName = localStorage.getItem('province');
          const current = localStorage.getItem('currentMonth');
          const provinceId = localStorage.getItem('provinceID');
    
    
          if (value !== null) {
            setBearer(value);
          }
          if (permitsss !== null) {
            const parsedPermits = JSON.parse(permitsss);
            const permitNames = parsedPermits.map(permit => permit.name);
            setPermits(permitNames);
            // console.log(permitNames);
          }
          if (value1 !== null) {
            setUser(value1);
          }
          if (continentName !== null) {
            setContinent(continentName);
          }
          if (regionName !== null) {
            setRegion(regionName);
          }
          if (provinceName !== null) {
            setProvince(provinceName);
          }
    
          if (value8 !== null) {
            setValidity(value8);
          }
          if (current !== null) {
            setCurrentMonth(new Date(current));
          }
          if (provinceId !== null) {
            setProvinceID(provinceId);
          }
          if (value3 !== null) {
            setAdmin(value3);
          }
          if (value7 !== null) {
            setCompany(value7);
          }
        } catch (e) {
          alert('Failed to fetch the input from storage');
        }
      };
    
      useEffect(() => {
        readData();
      }, []);
    
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${bearer}`
      };
         const uploadRemittance = async (file) => {
                         setCreateLoading(true);
                     
                         try {
                     
                           const formData = new FormData();
                           formData.append('file', file);
                           formData.append('bank', selectedBanks);
                           formData.append('customer_id', selectedCustomer);
                           formData.append('transaction_date', selectedDate);
                          //  formData.append('mode', selectedPaymentMode);
                           formData.append('cheque_number', teller);
                     
                     
                           const response = await axios.post(
                             `${BASE_URL}/upload_remittance_payment_new`,
                             formData,
                             {
                               headers: {
                                 'Content-Type': 'multipart/form-data',
                                 'Authorization': `Bearer ${bearer}`
                               }
                             }
                           );
                     
                           console.log(response, "heeee");
                           // setBalances(response.data.data);
                           // handleClose();
                           // Reset form fields
                            setBalances(response.data.data);
                            setUuid(response.data.data[0].uuid);
                         
                          //  Swal.fire({
                          //    icon: 'success',
                          //    title: 'Successful',
                          //    text: response.data.message,
                          //  });
                           // toast.success(response.data.message);
                         } catch (error) {
                           let errorMessage = 'An error occurred. Please try again.';
                           if (error.response && error.response.data && error.response.data.message) {
                             if (typeof error.response.data.message === 'string') {
                               errorMessage = error.response.data.message;
                             } else if (Array.isArray(error.response.data.message)) {
                               errorMessage = error.response.data.message.join('; ');
                             } else if (typeof error.response.data.message === 'object') {
                               errorMessage = JSON.stringify(error.response.data.message);
                             }
                             Swal.fire({
                               icon: 'error',
                               title: 'Failed',
                               text: JSON.stringify(error.response.data.message),
                             });
                           }
                           console.error(error);
                         } finally {
                           setCreateLoading(false);
                         }
                       };
      
const uploadRemittanceHandler = async () => {
  if (!uuid) {
    Swal.fire({
      icon: "warning",
      title: "Missing UUID",
      text: "Please upload an Excel file first before saving the remittance.",
    });
    return;
  }

  // ✅ Step 1: Confirm before submitting
  const confirmResult = await Swal.fire({
    title: "Are you sure?",
    text: "Do you want to submit this remittance?",
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, submit it!",
    cancelButtonText: "Cancel",
    reverseButtons: true,
  });

  if (!confirmResult.isConfirmed) {
    return; // user cancelled
  }

  try {
    setBalanceLoading(true);

    const response = await axios.post(
      `${BASE_URL}/save_temp_remittance`,
      { uuid },
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      }
    );

    console.log(response.data, "Save Temp Response");

    await Swal.fire({
      icon: "success",
      title: "Success",
      text: response.data.message || "Remittance saved successfully!",
    });

    // ✅ Reset table and close modal
    setBalances([]);
    onClose();

  } catch (error) {
    console.error(error);
    Swal.fire({
      icon: "error",
      title: "Failed",
      text:
        error.response?.data?.message ||
        "Something went wrong while saving the remittance.",
    });
  } finally {
    setBalanceLoading(false);
  }
};


        const fetchDebit1 = async () => {
            setLoading(true);
        
            try {
              const response = await axios.get(`${BASE_URL}/account/expenses`, { headers });
        
              const debt1 = response.data?.data;
              const oopt1 = debt1.map((item) => ({
                label: `${item.gl_code} - ${item.gl_name}`,
                value: item.id,
        
        
              }));
              setDebit1(oopt1);
        
        
        
            } catch (error) {
              const errorStatus = error.response.data.message;
              // console.error(errorStatus);
            } finally {
              setLoading(false);
            }
          };
          const fetchDebit3 = async () => {
            setLoading(true);
        
            try {
              const response = await axios.get(`${BASE_URL}/account/bank-accounts`, { headers });
        
              const debt1 = response.data?.data;
              const oopt1 = debt1.map((item) => ({
                label: `${item.gl_code} - ${item.gl_name}`,
                value: item.id,
        
        
              }));
              setDebit3(oopt1);
        
        
        
            } catch (error) {
              const errorStatus = error.response.data.message;
              // console.error(errorStatus);
            } finally {
              setLoading(false);
            }
          };
        
          const fetchDebit2 = async () => {
            setLoading(true);
        
            try {
              const response = await axios.get(`${BASE_URL}/account/payables`, { headers });
        
              const debt2 = response.data?.data;
              const oopt2 = debt2.map((item) => ({
                label: `${item.gl_code} - ${item.gl_name}`,
                value: item.id,
        
        
              }));
              setDebit2(oopt2);
        
        
        
            } catch (error) {
              const errorStatus = error.response.data.message;
              // console.error(errorStatus);
            } finally {
              setLoading(false);
            }
          };
          const fetchDebit4 = async () => {
            setLoading(true);
        
            try {
              const response = await axios.get(`${BASE_URL}/account/cash`, { headers });
        
              const debt2 = response.data?.data;
              const oopt2 = debt2.map((item) => ({
                label: `${item.gl_code} - ${item.gl_name}`,
                value: item.id,
        
        
              }));
              setDebit4(oopt2);
        
        
        
            } catch (error) {
              const errorStatus = error.response.data.message;
              // console.error(errorStatus);
            } finally {
              setLoading(false);
            }
          };
        
          useEffect(() => {
            if (bearer) {
              fetchDebit1();
              fetchDebit2();
              fetchDebit3();
              fetchDebit4();
            }
          }, [bearer]);

  const handlePrinter = () => window.print(); 

   const fetchSupplierss = async () => {
           
              try {
                const response = await axios.get(`${BASE_URL}/customer/loan-customers`, { headers });
                console.log(response)
                // const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
                const results = response.data?.data?.data;
                console.log("results:", results)
                const options = results.map((item) => ({
                  label: item.name,
                  value: item.id,
                }));
               
                setSelectOptions(options);
              } catch (error) {
                const errorStatus = error.response?.data?.message;
                console.log(errorStatus);
               
              } finally {
                
              }
            };
  
            const fetchCustomers = async () => {
            
              try {
                const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
                console.log(response)
                // const response = await axios.get(`${BASE_URL}/customer/no-pagination`, { headers });
                const results = response.data?.data;
                console.log("results:", results)
                const options = results.map((item) => ({
                  label: item.name,
                  value: item.id,
                  balance: item.balance
                }));
                setCus(options);
              } catch (error) {
                const errorStatus = error.response?.data?.message;
                console.log(errorStatus);
                setCus([]);
              } finally {
              
              }
            };
      
             const fetchLoans = async () => {
               
                try {
                  const response = await axios.get(`${BASE_URL}/account/fetch-loans`, { headers });
                  const results = response.data?.data;
            
                  const options1 = results.map((item) => ({
                    label: item.description,
                    value: item.id,
                    interest: item.interest
                  }));
                  setLoans(options1);
                  // setSelectOptions(options);
                } catch (error) {
                  const errorStatus = error.response?.data?.message;
                  console.log(errorStatus);
                  setLoans([]);
                } finally {
                
                }
              };
      
               useEffect(() => {
              if (bearer) {
                fetchSupplierss();
                fetchLoans();
                fetchCustomers();
              }
            }, [bearer]);

  useEffect(() => {
    const fetchReference = async () => {
      setLoadingRef(true);
      try {
        const res = await axios.get(`${BASE_URL}/generate-sales-invoice-code`, {
          headers: {
            Authorization: `Bearer ${bearer}`,
            Accept: "application/json",
          },
        });
        if (res?.data) {
          const payload = res.data;
          const d =
            payload?.data ??
            payload?.code ??
            payload?.reference ??
            payload?.number ??
            payload?.data?.code;
          let ref = "";
          if (typeof d === "string" || typeof d === "number") {
            ref = d;
          } else if (d && typeof d === "object") {
            ref = d.code || d.reference || d.number || "";
          }
          setReference(ref ? String(ref) : "");
        }
      } catch (error) {
        console.error("Error fetching journal reference:", error);
      } finally {
        setLoadingRef(false);
      }
    };

    if (isOpen) {
      fetchReference();
    }
  }, [isOpen]);

     useEffect(() => {
    const fetchIncome = async () => {
      setLoading(true);
      try {
      const response = await axios.get(`${BASE_URL}/account/fetch-loans`, {headers});
      const inc = response.data?.data;
      setIncomeAccount(inc);

    } catch (err) {
        console.error("Error fetching accounts:", err);
        setIncomeAccount([]);
      } finally {
        setLoading(false);
      }
    };
    if (isOpen) {
      fetchIncome();
    }
  }, [isOpen]);
 

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  useEffect(() => {
    const fetchAccounts = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) return;
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/v1/account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const payload = res?.data;
        // assume payload.data is the array, or payload itself
        let raw = payload?.data ?? payload;
        // If payload.data.data nested
        if (raw && typeof raw === "object" && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        console.error("Error fetching accounts:", err);
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };

    if (isOpen) {
      fetchAccounts();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const addLine = () => {
    setRows(prev => [
      ...prev,
      { accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false },
    ]);
  };

  const duplicateRow = (index) => {
    setRows(prev => {
      const newRows = [...prev];
      // create a new empty row, not a copy of the previous one
      const emptyRow = { accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setRows(prev => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChange = (index, field, value) => {
    setRows(prev => {
      if (field === "showDropdown") {
        const newRows = [...prev];
        newRows[index] = { ...newRows[index], showDropdown: value };
        return newRows;
      }

      const newRows = [...prev];
      const row = { ...newRows[index] };

      if (field === "debit") {
        row.debit = value;
        if (value && parseFloat(value) > 0) {
          row.credit = "0";
        }
      } else if (field === "credit") {
        row.credit = value;
        if (value && parseFloat(value) > 0) {
          row.debit = "0";
        }
      } else if (field === "account") {
        // value is the selected account object (from our dropdown click)
        row.accountId = value?.id ?? "";
        // build display string of code + name
        row.accountDisplay = `${value?.gl_code ?? value?.code ?? ""} - ${value?.gl_name ?? value?.name ?? ""}`;
      } else {
        row[field] = value;
      }

      newRows[index] = row;
      return newRows;
    });
  };

  const totalDebit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.debit) || 0),
    0
  );
  const totalCredit = balances.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );

  const handleSaveJournal = async () => {
    const token = localStorage.getItem("authToken");

    // Basic validation:
    if (!transactionDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Date",
        text: "Please select a transaction date.",
        confirmButtonText: "Okay",
        allowOutsideClick: false,
        didOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) swalContainer.style.zIndex = '99999';
        },
      });
      return;
    }

    // Each row must have an account, description, and either a debit or credit (but not both)
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      const hasDebit = r.debit !== "" && !isNaN(parseFloat(r.debit)) && parseFloat(r.debit) > 0;
      const hasCredit = r.credit !== "" && !isNaN(parseFloat(r.credit)) && parseFloat(r.credit) > 0;
      if (!r.accountId) {
        Swal.fire({
          icon: "warning",
          title: "Missing Account",
          text: `Please select an account for row ${i + 1}.`,
          confirmButtonText: "Okay",
          allowOutsideClick: false,
          didOpen: () => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) swalContainer.style.zIndex = '99999';
          },
        });
        return;
      }
      if (!r.description || String(r.description).trim() === "") {
        Swal.fire({
          icon: "warning",
          title: "Missing Description",
          text: `Please add a description for row ${i + 1}.`,
          confirmButtonText: "Okay",
          allowOutsideClick: false,
          didOpen: () => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) swalContainer.style.zIndex = '99999';
          },
        });
        return;
      }
      if (!(hasDebit || hasCredit)) {
        Swal.fire("Missing Amount", `Please enter a debit or credit amount for row ${i + 1}.`, "warning");
        return;
      }
      if (hasDebit && hasCredit) {
        Swal.fire("Invalid Row", `Row ${i + 1} has both debit and credit. Only one is allowed.`, "warning");
        return;
      }
    }

    const account_id = rows.map(r => String(r.accountId));
    const direction = rows.map(r => {
      const hasDebit = r.debit !== "" && !isNaN(parseFloat(r.debit)) && parseFloat(r.debit) > 0;
      return hasDebit ? "1" : "2";
    });
    const description = rows.map(r => r.description ?? "");
    const amount = rows.map(r => {
      const hasDebit = r.debit !== "" && !isNaN(parseFloat(r.debit)) && parseFloat(r.debit) > 0;
      return hasDebit ? parseFloat(r.debit) : parseFloat(r.credit || 0);
    });

    const payload = {
      jv_number: reference,
      all_debit: totalDebit,
      all_credit: totalCredit,
      account_id,
      direction,
      transaction_date: transactionDate,
      description,
      amount,
    };

    setIsSaving(true);
    try {
      const res = await axios.post(`${BASE_URL}/v1/journal/post-entries`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      Swal.fire({
        imageUrl: verified,
        title: "Success!",
        text: res.data.message || "Journal entry saved successfully!",
        confirmButtonText: "Okay",
        imageWidth: 48,
        imageHeight: 48,
        customClass: {
          popup: classes.myText,
          title: classes.myTitle,
          confirmButton: classes.myButton,
        },
        allowOutsideClick: false,
        didOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) swalContainer.style.zIndex = '99999';
        },
      });

      setRows([{ accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false }]);
      setTransactionDate("");
    } catch (error) {
      console.error("Save journal error:", error);

      let msg = "Network error";
      if (error?.response?.data) {
        const data = error.response.data;
        msg = data.message || data.error || JSON.stringify(data);
      } else if (error.message) {
        msg = error.message;
      }

      Swal.fire({
        imageUrl: crop,
        imageWidth: 48,
        imageHeight: 48,
        title: "Failed!",
        confirmButtonText: "Okay",
        text: msg,
        customClass: {
          popup: classes.myText,
          title: classes.myTitle,
          confirmButton: classes.myDeclineButton,
        },
        allowOutsideClick: false,
        didOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) swalContainer.style.zIndex = '99999';
        },
      });

    } finally {
      setIsSaving(false);
    }
  };


  

    const incomeOptions = incomeAccount.map((item) => ({
      label: item.description,
      value: item.id,
    }));

    const handleAccountChange = (selectedOption) => {
    setSelectedAccount(selectedOption.value);
  };

    const uploadStatement3 = async (file) => {
      setCreateLoading(true);    
      try {    
        const formData = new FormData();
        formData.append('doc', file);
        formData.append('loan_name', selectedAccount);
        formData.append('transaction_date', transactionDate);
        formData.append('reference_number', reference);
        const response = await axios.post(
          `${BASE_URL}/account/upload-staff-loan-ordinary`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${bearer}`
            }
          }
        );
  
        console.log(response, "heeee");

        // handleClose();
        // handleShow2(true);
        // Reset form fields
        // setSelectedImage("");
        // Swal.fire({
        //   icon: 'success',
        //   title: 'Successful',
        //   text: response.data.message,
        // });
        // 
      } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
            errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
            errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
            errorMessage = JSON.stringify(error.response.data.message);
          }
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: JSON.stringify(error.response.data.message),
            didOpen: () => {
              const swalEl = document.querySelector('.swal2-container');
              if (swalEl) swalEl.style.zIndex = '20000';
            }
          });
        }
        console.error(error);
      } finally {
        setCreateLoading(false);
      }
    };
   const handleCustomerChange = (selectedOption) => {
        setSelectedCustomer(selectedOption.value);
        setOutstanding(selectedOption.balance);
      };
 const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };
   const handlePaymentChange = (selectedOption) => {
             if (selectedOption) {
                 const selectedValue = selectedOption.value; // Access the value here
                 console.log('Selected value:', selectedValue); // For debugging
                 // Set the selected payment mode or perform any other action you need
                 // setSelectedPaymentMode(selectedValue); // Assuming you're updating the payment mode
           
                 setSelectedBanks(selectedValue);
           
             } else {
                 console.error('Selected option is undefined');
             }
           };
           
  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <h3 className={classes.title}>Remittance - Excel Upload</h3>
        <Row>
          <Col md={8}>
            <p className={classes.subtitle}>
            Upload multiple remittance entries from an Excel file.
            </p>
          </Col>
          <Col md={4} style={{ textAlign: "right" }}>
            <p className={classes.subtitle}>
              <a
                href={`https://account-api.patna.ng/api/v1/download-loan-opening-balance`}
                download
                style={{ margin: "0 0 20px 0", color: "#174384" }}
              >
                 {" "}
              </a>
            </p>
          </Col>
        </Row>
        <Row style={{ paddingTop: 20, paddingBottom: 0, fontSize: "12px" }}>
           <Col md={6}>
                    <Form.Group controlId="customer" className="mb-3">
                      <Form.Label>Customer</Form.Label>
                      <Select
                        onChange={handleCustomerChange}
                        options={cus}
                        menuPortalTarget={document.body}
                         styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                control: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  minHeight: "32px", // reduce overall height
                  height: "32px", // enforce height
                  padding: "0 4px", // tighter spacing
                  borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                }),

                valueContainer: (base) => ({
                  ...base,
                  padding: "0 6px", // reduce vertical padding inside the box
                  height: "28px",
                }),

                indicatorsContainer: (base) => ({
                  ...base,
                  height: "28px",
                }),

                option: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                  color: "black",
                }),

                menuList: (base) => ({
                  ...base,
                  maxHeight: "200px",
                  overflowY: "auto",
                }),
              }}
                      />
                    </Form.Group>
                  </Col>
                   <Col md={3}>
                            <Form.Group controlId="transactionDate" className="mb-3">
                              <Form.Label >Transaction Date</Form.Label>
                              <Form.Control
                                type="date"
                                onChange={handleDateChange}
                                value={selectedDate}
                                // min={minDate}
                                // max={maxDate}
                                   style={{ width: "100%", fontSize: "12px" }}
                              />
                            </Form.Group>
                          </Col>
          
        </Row>

        <Row style={{ paddingTop: 0, paddingBottom: 10, fontSize: "12px",}}>
           <Col md={4} >
          <Form.Group controlId="bank" className="mb-3">
            <Form.Label>Bank</Form.Label>
            <Select
              onChange={handlePaymentChange}
              options={
               debit3
              }
              menuPortalTarget={document.body}
               styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),

                control: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  minHeight: "32px", // reduce overall height
                  height: "32px", // enforce height
                  padding: "0 4px", // tighter spacing
                  borderColor: state.isFocused ? "#2684ff" : base.borderColor,
                  boxShadow: state.isFocused ? "0 0 0 1px #2684ff" : "none",
                }),

                valueContainer: (base) => ({
                  ...base,
                  padding: "0 6px", // reduce vertical padding inside the box
                  height: "28px",
                }),

                indicatorsContainer: (base) => ({
                  ...base,
                  height: "28px",
                }),

                option: (base, state) => ({
                  ...base,
                  fontSize: "12px",
                  backgroundColor: state.isFocused ? "#f0f0f0" : "white",
                  color: "black",
                }),

                menuList: (base) => ({
                  ...base,
                  maxHeight: "200px",
                  overflowY: "auto",
                }),
              }}
            />
          </Form.Group>
        </Col>
         
                 <Col md={4} >
                   <Form.Group controlId="tellerNo" className="mb-3">
                     <Form.Label>Cheque/Teller No</Form.Label>
                     <Form.Control
                       type="text"
                       value={teller}
                       onChange={(e) => setTeller(e.target.value)}
                       style={{ height: "32px",}}
                     />
                   </Form.Group>
                 </Col>
          <Col md={4}>
              <Form.Label>Upload Excel</Form.Label>
             <Form.Control
                type="file"
              accept=".xls,.xlsx"
                style={{ fontSize: "12px" }}
                placeholder="Choose file"
                // onChange={handleImageChange}
                // onBlur={uploadStatement3}
                  // onChange={(e) => setExcelFile(e.target.files[0])}
                  onChange={(event) => {
                                   const file = event.target.files[0];
                                   if (file) {
                                     handleImageChange(event);
                                     uploadRemittance(file); 
                                     event.target.value = "";
                                   }
                                 }}
              />
          </Col>
        </Row>
        <div className={classes.mainTable} style={{ paddingBottom: 30 }}>
          <div className="table-responsive" style={{ maxHeight: '200px', overflowY: 'auto', }}>
           <table className="table display bg-white m-0 card-table" style={{ width: "100%", borderCollapse: "collapse" }}>
  <thead style={{ whiteSpace: "nowrap", textAlign: "left" }}>
    <tr style={{ fontSize: 13 }}>
      <th
        style={{
          position: "sticky",
          top: 0,
          background: "#f5f7fb",
          zIndex: 2,
          width: "5%",           // fixed small width
          padding: "7px 10px",
        }}
      >
        S/N
      </th>

      <th
        style={{
          position: "sticky",
          top: 0,
          background: "#f5f7fb",
          zIndex: 2,
          padding: "7px 10px",
          textAlign: "left",
          width: "auto",          // let this stretch
        }}
      >
        Description
      </th>

      <th
        style={{
          position: "sticky",
          top: 0,
          background: "#f5f7fb",
          zIndex: 2,
          textAlign: "right",
          width: "15%",           // fixed width
          padding: "7px 10px",
        }}
      >
        Debit
      </th>

      <th
        style={{
          position: "sticky",
          top: 0,
          background: "#f5f7fb",
          zIndex: 2,
          textAlign: "right",
          width: "15%",           // fixed width
          padding: "7px 10px",
        }}
      >
        Credit
      </th>
    </tr>
  </thead>

  <tbody>
    {balances.map((item, index) => (
      <tr key={index} style={{ fontSize: 13 }}>
        <td style={{ padding: "6px 10px" }}>{index + 1}</td>

        <td style={{ padding: "6px 10px", textAlign: "left", wordBreak: "break-word" }}>
          {item.description}
        </td>

        <td style={{ textAlign: "right", padding: "6px 10px" }}>0.00</td>

        <td style={{ textAlign: "right", padding: "6px 10px" }}>
          {parseFloat(item.amount).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </td>
      </tr>
    ))}
  </tbody>
</table>

          </div>
        </div>
        {/* <div style={{ marginTop: "15px" }} />
          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Closing Balance:</Form.Label>
                <Form.Control
                  type="text"
                  value={closingBalance2}
                  name="total"
                  disabled
                  style={{ textAlign: 'right' }}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
            </Col>
            <Col md={6}>
              <Row>
                <Col md={6}>
                <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                  <Form.Label>Total Credit:</Form.Label>
                  <Form.Control
                    type="text"
                    name="total"
                    value={totalAmountCredit2}
                    disabled
                    style={{ textAlign: 'right' }}
                  />
                </Form.Group>
                </Col>
                <Col md={6}>
                <Form.Group className="mb-3" style={{ textAlign: "right" }}>
                  <Form.Label>Total Debit:</Form.Label>
                  <Form.Control
                    type="text"
                    name="total"
                    value={totalAmountDebit2}
                    disabled
                    style={{ textAlign: 'right' }}
                  />
                </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
        </div> */}

        <Row>
          <Col md={8} xs={8}>
            {/* <Button className={classes.submitBtn} onClick={addLine} disabled>
              + Add Line
            </Button> */}
          </Col>
          <Col md={2} xs={2}>
            <div className={classes.totalBox}>              
              <span>Total Debit</span>
              <strong>{totalDebit.toFixed(2)}</strong>
            </div>
          </Col>
          <Col md={2} xs={2}>
            <div className={classes.totalBox}>              
              <span>Total Credit</span>
              <strong>
                {parseFloat(totalCredit).toLocaleString('en-US', {
                  minimumIntegerDigits: 1,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}</strong>
            </div>
          </Col>
        </Row>
        {/* <div className={classes.totalRow}>
          <div className={classes.actionRow}>
            <Button className={classes.submitBtn} onClick={addLine} disabled>
              + Add Line
            </Button>
          </div>
          <div className={classes.totalBox}>
            <span>Total Debit</span>
            <strong>{totalDebit.toFixed(2)}</strong>
          </div>
          <div className={classes.totalBox}>
            <span>Total Credit</span>
            <strong>{totalCredit.toFixed(2)}</strong>
          </div>
        </div> */}

        <div className={classes.footerButtons}>
          <button
            className={classes.resetBtn}
            onClick={onClose}
          >
            Close
          </button>
          <button className={classes.printBtn} onClick={handlePrinter}>Print</button>
          <button
            className={classes.submitBtn}
            onClick={uploadRemittanceHandler}
            disabled={balanceLoading}
          >
            {balanceLoading ? (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                <Spinner animation="border" size="sm" />
                Saving...
              </span>
            ) : (
              "Upload Balance"
            )}
          </button>
        </div>

        <button className={classes.closeBtn} onClick={onClose}>
          ×
        </button>
      </div>
      {createLoading && (
              <div className={classes.overlay}>
                <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
              </div>
            )}
      
    </div>
  );
}

export default RemitanceUpload;
